const productService = ['Professional Service', 'IP Trading', 'Product Selling', 'NFT', 'Service', 'Rental', 'Others'];

export default productService;
